module.exports = __webpack_public_path__ + "img/IMG_0211.aaa5e402.jpg";